/* eslint-disable no-underscore-dangle */
// eslint-disable-next-line no-unused-vars
import { h } from 'preact';
import { decode } from 'he';

/**
 * Strip html tag from the content
 * @param {string} html - Current html content
 * @returns {string}
 */
const strip = html => {
  const doc = new DOMParser().parseFromString(html, 'text/html');
  return doc.body.textContent || '';
};

const getType = (postTypes, type) => {
  let result = '';
  Object.keys(postTypes).forEach(item => {
    if (item === type) {
      if (postTypes[item].name === 'Posts') {
        result = <span className="deepsea-tag">Insights</span>;
      } else {
        result = <span className="deepsea-tag">{postTypes[item].name}</span>;
      }
    }
  });
  return result;
};

const Result = ({ entry, types, jetpack }) => (
  <article className="search-modal-results-item">
    {entry.subtype !== 'people' && (
      <header>
        <a href={entry.url}>{decode(entry.title)}</a>
      </header>
    )}
    {entry.subtype === 'people' && (
      <header>
        <span>{decode(entry.title)}</span>
      </header>
    )}
    {entry.subtype && !jetpack && <span>{getType(types, entry.subtype)}</span>}
    {entry.subtype && jetpack && (
      <span>
        <span className="deepsea-tag">{entry.subtype_name}</span>
      </span>
    )}
    {entry._embedded !== undefined && (
      <div className="search-modal-excerpt">
        <p>{strip(entry._embedded.self[0].excerpt.rendered)}</p>
      </div>
    )}
    {entry.excerpt !== undefined && (
      <div className="search-modal-excerpt">
        <p>{strip(entry.excerpt)}</p>
      </div>
    )}
    {entry.subtype !== 'people' && <div className="search-modal-link">{entry.url}</div>}
  </article>
);

export default Result;
